const CryptoNavigationCardTypeEnum = {
  ANSWER: 'answer',
  QUESTION: 'question',
};

export { CryptoNavigationCardTypeEnum };
